/* import __COLOCATED_TEMPLATE__ from './empty.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsNoteDiagnosisTreatmentPlanEmpty extends Component {}
